import React from 'react';
import Search from '../common/search';


export default function SearchFilter({searchPlaceholder, handleSearch, noPadding, fullWidth}) {
    return (
        <div className="searchfilter d-flex justify-content-between">
            <div className={`search-area ${noPadding ? 'p-0 no-pad' : ''} ${fullWidth ? 'full-width' : ''}`}>
                <Search placeholder={searchPlaceholder} onSearch={handleSearch} hideIcon={true} />
            </div>
        </div>
    );
}